import React from 'react';
import './textarea.css'



const Textarea = (props) => {
    return ( 
        <fieldset className='container-input'>
            <label className='title-inputt' htmlFor={props.id}>
                {props.label}
            </label>
            <fieldset className='input-wrapper' >
            <input className='inputt'
            placeholder={props.placeholder}
              type={props.type}
            onChange={props.onChange}
            value={props.value}/>
          

</fieldset>
        </fieldset>
     );
}
 
export default Textarea;